export default interface Mockable {
  setMockMode(testCase: string): void;
}

export function isMockable(object: unknown): object is Mockable {
  return (<Mockable>object).setMockMode !== undefined;
}
